<script>
import Simplert from 'vue2-simplert'
export default {
  name: 'survey',
  components: {
    Simplert
  },
  data () {
    return {
      salesPerson: '',
      haaId: '',
      customerName: 'Jane Jones',
      surveyLoading: true,
      klimaVmodelData: [],
      el: '1',
      social: '1',
      affald: '1',
      contactId: '',
      surveyData: [],
      allUserSelectedData: [],
      groupedUserSurveyData: {
        KlimaSurveyEconomy: [],
        KlimaSurveySocial: [],
        KlimaSurveyEnvironment: [],
        KlimaSurveyFag: []
      },
      surveyId: ''
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    var contactId = searchParams.get('contactId')
    this.contactId = contactId
    var appointmentId = searchParams.get('appointmentId')
    this.appointmentId = appointmentId
    this.displaySurvey()
    this.getUserSurvey()
    localStorage.removeItem('userSurvey')
  },
  methods: {
    displaySurvey () {
      /* eslint-disable no-unused-vars */
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getSurvey'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.surveyData = res.data
            var index = 0
            for (var data in res.data) {
              var dataObjName = data
              this.klimaVmodelData.push({})
              for (var data1 in res.data[data]) {
                var dataPropName = data1
                this.klimaVmodelData[index][dataPropName] = 0
              }
              index++
            }

            // console.log(Object.keys(res.data.KlimaSurveyEconomy))
            // console.log(Object.keys(res.data))
          } else {
            this.$toastr('error', 'Error in displaySurvey()')
          }
        },
        response => {
          this.$toastr('error', 'Error in displaySurvey()')
        }
      )
      this.surveyLoading = true
    },
    getUserSurvey () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: JSON.stringify({
          operation: 'getUserSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          // All user selected survey
          for (var economyAll in res.data.main[0].economy) {
            this.surveyId = res.data.main[0].klimasurveryId
            if (res.data.main[0].economy[economyAll].value === '1') {
              this.allUserSelectedData.push(res.data.main[0].economy[economyAll].economicId)
            }
          }
          for (var socialAll in res.data.main[0].social) {
            if (res.data.main[0].social[socialAll].value === '1') {
              this.allUserSelectedData.push(res.data.main[0].social[socialAll].socialId)
            }
          }
          for (var environmentAll in res.data.main[0].environment) {
            if (res.data.main[0].environment[environmentAll].value === '1') {
              this.allUserSelectedData.push(res.data.main[0].environment[environmentAll].environmentId)
            }
          }
          for (var economy in res.data.main[0].economy) {
            this.surveyId = res.data.main[0].klimasurveryId
            if (res.data.main[0].economy[economy].value === '1') {
              this.groupedUserSurveyData.KlimaSurveyEconomy.push(
                {
                  typeId: res.data.main[0].economy[economy].economicId,
                  title: res.data.main[0].economy[economy].title,
                  value: res.data.main[0].economy[economy].value
                })
            }
          }
          // Grouped user selected survey
          for (var social in res.data.main[0].social) {
            if (res.data.main[0].social[social].value === '1') {
              this.groupedUserSurveyData.KlimaSurveySocial.push(
                {
                  typeId: res.data.main[0].social[social].socialId,
                  title: res.data.main[0].social[social].title,
                  value: res.data.main[0].social[social].value
                })
            }
          }
          for (var environment in res.data.main[0].environment) {
            if (res.data.main[0].environment[environment].value === '1') {
              this.groupedUserSurveyData.KlimaSurveyEnvironment.push(
                {
                  typeId: res.data.main[0].environment[environment].environmentId,
                  title: res.data.main[0].environment[environment].title,
                  value: res.data.main[0].environment[environment].value
                })
            }
          }
          for (var fag in res.data.main[0].fag) {
            if (res.data.main[0].fag[fag].value !== '0') {
              this.groupedUserSurveyData.KlimaSurveyFag.push(
                {
                  typeId: res.data.main[0].fag[fag].fagId,
                  title: res.data.main[0].fag[fag].title,
                  value: res.data.main[0].fag[fag].value
                })
            }
          }
          this.surveyLoading = false
          setTimeout(() => {
            this.countSurvey()
          }, 500)
        },
        response => {
          this.$toastr('error', 'Error in getUserSurvey()')
        }
      )
    },
    countSurvey () {
      var survey = document.querySelectorAll('#klimaSurvey .survey-counter')
      for (var i = 0; i < survey.length; i++) {
        var surveyId = survey[i].id
        var checkedSurvey = document.querySelectorAll('#klimaSurvey #' + surveyId + ' .counter-icon.el-icon-success')
        for (var x = 0; x < checkedSurvey.length; x++) {
        }
        document.querySelector('#klimaSurvey #' + surveyId + ' .checked-survey').innerText = checkedSurvey.length
        var counterIcon = document.querySelectorAll('#klimaSurvey #' + surveyId + ' .counter-icon')
        for (var j = 0; j < counterIcon.length; j++) {
        }
        document.querySelector('#klimaSurvey #' + surveyId + ' .total-survey').innerText = counterIcon.length
      }
    },
    editSurvey (type) {
      console.log('type', type)
      localStorage.setItem('userSurvey', JSON.stringify(this.groupedUserSurveyData))
      this.$router.push('/klima/editsurvey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId + '&surveyId=' + this.surveyId + '&type=' + type)
    },
    editFag () {
      this.$router.push('/klima/registration?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId + '&surveyId=' + this.surveyId)
    },
    goToCheckList () {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    }
  },
  computed: {}
}
</script>
<template>
<div id="klimaSurvey" class="animated fadeIn">
    <div class="clearfix fullHeight">
      <!-- page header -->
      <div class="col-12 lg-col-4 md-col-9 py3 mx-auto mt3 shadow">
        <div class="clearfix primarycolor flex justify-start items-center pointer mb3" @click="goToCheckList()">
          <span class="mr1"><i class="el-icon-back"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
        </div>
        <div class="primarycolor mb2">
          <span class="mr1 h4 m0 p0 line-height-1">
            <i class="el-icon-success"></i>
          </span>
          <span class="h5 gibson line-height-1 m0 p0">
            Checkliste<!--  - <span class="darkblue">{{customerName}}</span> -->
          </span>
        </div>
        <div class="clearfix" v-if="surveyLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div v-else>
          <!-- category item -->
          <div v-for="(survey, index) in surveyData" :key="index">
            <div :id="index" class="p3 highlights survey-counter mb3" v-if="index != 'KlimaSurveyFag'">
              <!-- question topic and count -->
              <div class="primarycolor gibson flex justify-between items-center mb2">
                <div class="flex justify-start items-center">
                  <span class="h3 mr1 line-height-1 mb0 p0">
                    <i class="el-icon-money" v-if="index == 'KlimaSurveyEconomy'"></i>
                    <i class="el-icon-user" v-else-if="index == 'KlimaSurveySocial'"></i>
                    <i class="el-icon-c-scale-to-original" v-else-if="index == 'KlimaSurveyEnvironment'"></i>
                  </span>
                  <span class="h5 m0 p0 line-height-1">{{index.replace("KlimaSurvey", "")}}</span>
                </div>
                <div class="">
                  <span class="h6 line-height-1 m0 p0">
                     <span class="checked-survey">0</span> / <span class="total-survey">0</span>
                  </span>
                </div>
              </div>
              <!-- question text and input -->
              <div class="flex justify-between items-center mt2" v-for="(surveyQuestion, index1) in surveyData[index]" :key="index1">
                <p class="h6 regular gibson darkblue line-height-1 m0 p0 caps">
                  {{surveyQuestion}}
                </p>
                <i class="h4 counter-icon green el-icon-success" v-if="allUserSelectedData.includes(index1)"></i>
                <i class="h4 counter-icon red el-icon-error" v-else></i>
                <!-- .includes("Mango"); -->
              </div>
              <!-- button -->
            <button @click="editSurvey(index.replace('KlimaSurvey', ''))" class="mt2 col-12 center outlined-primary-button h5 regular gibson line-height-1 p2">
                <span class="mr1"><i class="el-icon-edit"></i></span>
                <span>Ret checkliste</span>
              </button>
            </div>
          </div>
          <!-- edit buttons -->
          <!-- button -->
          <div class="flex flex-column justify-center items-center">
            <button class="flex col-12 justify-center items-center outlined-primary-button h5 gibson line-height-1 p2 " @click="editFag()">
              <span class="mr1"><i class="el-icon-edit"></i></span>
              <span>Ret fag</span>
            </button>
          </div>
        </div>
      </div>
    <div class="py4"></div> 
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<style>
.el-radio__inner {
  border-color: rgba(25, 163, 192,1);
  width:18px;
  height:18px;
  border-width: 2px;
}
.el-radio__input.is-checked .el-radio__inner {
  background-color: rgba(25, 163, 192,1);
  background: rgba(25, 163, 192,1);
  color: rgba(25, 163, 192,1);
  border-color: rgba(25, 163, 192,1);
}
.el-radio__inner::after {
  background-color: rgba(25, 163, 192,1);
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// survey.vue?97854efa